import { selectProjectHasLoaded } from "features/entity-caching/project/module"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { selectEntityById } from "panels/content/side-panel/slice"
import { selectSingleLayer } from "panels/content/side-panel/slice.new"
import { zoomToEntity } from "plugins/plugin-registry"
import { useEffect } from "react"
import { useLocation, useNavigate } from "react-router"

export const ENTITY_ID_PARAM = "entityId"

export const useEntityIdDeepLink = () => {
    const dispatch = useAppDispatch()
    const projectHasLoaded = useAppSelector(selectProjectHasLoaded)
    const location = useLocation()
    const navigate = useNavigate()
    const entityId = new URLSearchParams(location.search).get(ENTITY_ID_PARAM) ?? ""
    const entity = useAppSelector(selectEntityById(entityId))

    useEffect(() => {
        if (!entityId || !projectHasLoaded || !entity) return

        dispatch(selectSingleLayer({ id: entityId }))
        zoomToEntity(entity)

        const params = new URLSearchParams(location.search)
        params.delete(ENTITY_ID_PARAM)
        navigate({ search: params.toString() }, { replace: true })
    }, [dispatch, entity, entityId, projectHasLoaded, location.search, navigate])
}
